import { defineStore } from "pinia"
import { fetchWrapper, BASE_URL, trimHora, formatFecha, createDate, ACTIVO } from "@/helpers"

// const baseUrl = `${import.meta.env.VITE_API_URL}/users`

export const useClasesStore = defineStore("clasesStore", {
  state: () => {
    return {
      clases: [],
    }
  },
  getters: {
    actividadesFormateadas(state) {
      const arrayOfActividades = {}

      for (const idCategoria in state.clases) {
        const actividades = state.clases[idCategoria].map((clase) => {
          return { id: clase.idtipoactividad, label: clase.actividad, value: clase.idtipoactividad }
        })
        const actividadesWithoutRep = [...new Map(actividades.map((v) => [v.id, v])).values()]
        arrayOfActividades[idCategoria] = actividadesWithoutRep
      }
      return arrayOfActividades
    },
    sedesFormateadas(state) {
      const arrayOfSedes = {}

      for (const idCategoria in state.clases) {
        const sedes = state.clases[idCategoria].map((clase) => {
          return { id: clase.idsede, label: clase.lugar, value: clase.idsede, idactividad: clase.idtipoactividad }
        })
        const sedesWithoutRep = [...new Map(sedes.map((v) => [v.id, v])).values()]
        arrayOfSedes[idCategoria] = sedesWithoutRep
      }
      return arrayOfSedes
    },
  },
  actions: {
    async getClases(array_actividades) {
      const body = {
        add_date: 0,
        array_ids_actividades: array_actividades,
      }
      const clases = await fetchWrapper.post(`${BASE_URL}/get_clases_pases`, body)

      // update pinia state
      this.clases = await clases
    },
    async cancelPase(id_pase_clase) {
      const body = { id_pase_clase: id_pase_clase }
      const anulacion = await fetchWrapper.post(`${BASE_URL}/cancel_pase_clase`, body)
      await this.getUserPases()
    },
    async reservarClase(body) {
      return await fetchWrapper.post(`${BASE_URL}/save_pase_clase`, body)
    },
  },
})
